module.exports = __webpack_public_path__ + "gg.27dcb06371206b1d0f83.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gg.svg
// module chunks = styles